import React from "react";
import Wordmark from "../../assets/images/soundvista-wordmark.svg";
import arrow from "../../assets/images/arrow-cross-up.svg";
import orbIdle from "../../assets/images/vista-orb-idle.png";
import "./intro.scss";
import VistaAI from "../VistaAI/VistaAI";

const Intro = ({
  handleClickToExplore,
  vistaOpen,
  onOpenVista,
  onCloseVista,
}) => {
  return (
    <div className="soundvista_introWrapper bg-secondary">
      <div className="soundvista_intro">
        {/* Centered content */}
        <div className="soundvista_intro-center">
          <div className="soundvista_imageWrapper">
            <img src={Wordmark} alt="Sound Vista" />
            <div className="soundvista_explore_link" onClick={handleClickToExplore}>
              <p>Explore</p>
              <div className="soundvista_explore_imageWrapper">
                <img src={arrow} alt="" />
              </div>
            </div>
          </div>

          <p className="soundvista_tagline">
            The first immersive AI and Onchain social
            <br className="soundvista_tagline-break" />
            streaming platform for music and media.
          </p>
        </div>

        {/* Vista AI panel — right side when open */}
        {vistaOpen && (
          <div className="soundvista_intro-right">
            <VistaAI onClose={onCloseVista} />
          </div>
        )}

        {/* Ask Vista pill — bottom center */}
        {!vistaOpen && (
          <div className="soundvista_ask-vista-pill" onClick={onOpenVista}>
            <div className="soundvista_ask-vista-pill__left">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="7" cy="7" r="5" stroke="#C4C669" strokeWidth="1.5"/>
                <line x1="11" y1="11" x2="14" y2="14" stroke="#C4C669" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
              <span className="soundvista_ask-vista-pill__text">Ask Vista</span>
            </div>
            <img className="soundvista_ask-vista-pill__orb" src={orbIdle} alt="" />
          </div>
        )}
      </div>
    </div>
  );
};
export default Intro;
